import { render, staticRenderFns } from "./SnippetTrackingCard.vue?vue&type=template&id=1f5d6972&"
import script from "./SnippetTrackingCard.vue?vue&type=script&lang=js&"
export * from "./SnippetTrackingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports